import { View } from "./View";

export interface IDatePickerProps {
  name: string;
  startDate?: string;
  endDate?: string;
}

export const DatePicker = (props: IDatePickerProps) => {
  return (
    <View startDate={props.startDate} endDate={props.endDate} {...props} />
  );
};
